
  <header class="primary-dark-bg">
    <div class="container">
    <!-- Modern Bootstrap 5.3.7 Navigation -->
    <nav class="navbar navbar-expand-lg navbar-dark shadow-sm">
      <div class="container-fluid">
        
        <!-- Brand/Logo Section -->
        <a class="navbar-brand d-flex align-items-center" 
           [routerLink]="loggedIn() ? ['/app/welcome'] : ['/']"
           [attr.aria-label]="'Navigate to ' + (loggedIn() ? 'welcome' : 'home') + ' page'">
          <img src="assets/img/logo_white_tb.png" 
               alt="Intercessory Training Logo" 
               height="auto" 
               class="me-2">
        </a>
  
        <!-- Mobile Toggle Button -->
        <button class="navbar-toggler border-0" 
                type="button" 
                data-bs-toggle="collapse" 
                data-bs-target="#navbarContent"
                aria-controls="navbarContent" 
                aria-expanded="false" 
                aria-label="Toggle navigation"
                (click)="toggle()">
          <span class="navbar-toggler-icon"></span>
        </button>
  
        <!-- Collapsible Navigation Content -->
        <div class="navbar-collapse collapse" 
             id="navbarContent"
             [ngClass]="{ show: isExpanded }">
          
          <!-- Left Navigation Items -->
          <ul class="navbar-nav me-auto mb-2 mb-lg-0">
            
            <!-- About Training (Not Logged In) -->
            <li class="nav-item" *ngIf="!loggedIn()">
              <a class="nav-link" 
                 [routerLink]="['/learn-more']"
                 routerLinkActive="active"
                 [routerLinkActiveOptions]="{ exact: true }"
                 [attr.aria-label]="'NAV.ABOUT_TRAINING' | translate">
                <i class="fa fa-book-open me-1"></i>
                {{ 'NAV.ABOUT_TRAINING' | translate }}
              </a>
            </li>
  
            <!-- My Classes (Logged In) -->
            <li class="nav-item" *ngIf="loggedIn()">
              <a class="nav-link fw-semibold" 
                 [routerLink]="['/app/classes']"
                 routerLinkActive="active"
                 [routerLinkActiveOptions]="{ exact: true }"
                 [attr.aria-label]="'NAV.MY_CLASSES' | translate">
                <i class="fa fa-graduation-cap me-1"></i>
                {{ 'NAV.MY_CLASSES' | translate }}
              </a>
            </li>
  
            <!-- Prayer Guide (Logged In) -->
            <li class="nav-item" *ngIf="loggedIn()">
              <a class="nav-link" 
                 href="https://online.fliphtml5.com/qubm/gfru"
                 target="_blank"
                 rel="noopener noreferrer"
                 [attr.aria-label]="('NAV.PRAYER_GUIDE' | translate) + ' (opens in new window)'">
                <i class="fa fa-heart me-1"></i>
                {{ 'NAV.PRAYER_GUIDE' | translate }}
                <i class="fa fa-external-link ms-1 small"></i>
              </a>
            </li>
  
            <!-- E-Book (Logged In) -->
            <li class="nav-item" *ngIf="loggedIn()">
              <a class="nav-link" 
                 href="https://online.fliphtml5.com/qubm/xuvw/"
                 target="_blank"
                 rel="noopener noreferrer"
                 [attr.aria-label]="('NAV.EBOOK' | translate) + ' (opens in new window)'">
                <i class="fa fa-book me-1"></i>
                {{ 'NAV.EBOOK' | translate }}
                <i class="fa fa-external-link ms-1 small"></i>
              </a>
            </li>
  
            <!-- Download Certificate (Course Completed) -->
            <li class="nav-item" *ngIf="courseCompleted()">
              <a class="nav-link text-warning d-flex align-items-center" 
                 href="javascript:void(0)"
                 (click)="downloadCertificate()"
                 [attr.aria-label]="('NAV.DOWNLOAD_CERTIFICATE' | translate)">
                <i class="fa fa-download me-1"></i>
                <span class="me-1">{{ 'NAV.DOWNLOAD_CERTIFICATE' | translate }}</span>
                <i class="fa fa-certificate text-warning"></i>
              </a>
            </li>
  
            <!-- Need Help (Not Logged In) -->
            <li class="nav-item" *ngIf="!loggedIn()">
              <a class="nav-link" 
                 [routerLink]="['/contact-us']"
                 routerLinkActive="active"
                 [routerLinkActiveOptions]="{ exact: true }"
                 [attr.aria-label]="'NAV.NEED_HELP' | translate">
                <i class="fa fa-question-circle me-1"></i>
                {{ 'NAV.NEED_HELP' | translate }}
              </a>
            </li>
            
          </ul>
  
          <!-- Right Navigation Items -->
          <ul class="navbar-nav align-items-lg-center">
            
            <!-- Progress Section (Logged In Users) -->
            <li class="nav-item d-flex align-items-center me-3" *ngIf="loggedIn()">
              <div class="d-flex align-items-center progress-section">
                <circle-progress
                  #circleProgress
                  [percent]="getPercentage()"
                  [radius]="18"
                  [titleFontSize]="10"
                  [unitsFontSize]="8"
                  [showZeroOuterStroke]="true"
                  [showInnerStroke]="false"
                  [showSubtitle]="false"
                  [innerStrokeColor]="'#ffffff'"
                  [backgroundColor]="'transparent'"
                  [outerStrokeColor]="'#ffc107'"
                  [outerStrokeWidth]="3"
                  [animation]="false"
                  class="me-2">
                </circle-progress>
                <span class="small text-white-50 d-none d-md-inline">
                  {{ 'NAV.YOUR_PROGRESS' | translate }}
                </span>
              </div>
            </li>
  
            <!-- Authentication Buttons (Not Logged In) -->
            <li class="nav-item me-2" *ngIf="!loggedIn()">
              <a class="btn btn-outline-light btn-sm" 
                 [routerLink]="['/login']"
                 [attr.aria-label]="'NAV.LOGIN' | translate">
                <i class="fa fa-sign-in me-1"></i>
                {{ 'NAV.LOGIN' | translate }}
              </a>
            </li>
  
            <li class="nav-item me-2" *ngIf="!loggedIn()">
              <a class="btn btn-warning btn-sm text-dark fw-semibold" 
                 [routerLink]="['/register']"
                 [attr.aria-label]="'NAV.REGISTER' | translate">
                <i class="fa fa-user me-1"></i>
                {{ 'NAV.REGISTER' | translate }}
              </a>
            </li>
  
            <!-- User Actions (Logged In) -->
            <li class="nav-item" *ngIf="loggedIn()">
              <button class="btn btn-outline-light btn-sm" 
                      (click)="logout()"
                      [attr.aria-label]="'NAV.LOGOUT' | translate">
                <i class="fa fa-sign-out me-1"></i>
                {{ 'NAV.LOGOUT' | translate }}
              </button>
            </li>
  
            <!-- Admin Button (Admin Users) -->
            <li class="nav-item ms-2" *ngIf="loggedIn() && isAdmin && !isLoading">
              <a class="btn btn-warning btn-sm d-flex align-items-center justify-content-center" 
                 [routerLink]="['/backoffice/dashboard']"
                 [attr.aria-label]="'Navigate to admin dashboard'"
                 style="width: 40px; height: 40px;">
                <i class="fa fa-cog"></i>
              </a>
            </li>
            
          </ul>
          
        </div>
        
      </div>
    </nav>
    </div>
  </header>


